export enum AchievementClaimPeriodTypeId {
	RelativePeriod = 0,
	ExactPeriod = 1,
}